import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';
import { FormControl } from "@common/components/form-control";

import Tree from '@common/components/Tree';

import "./pedigree-folder.styles.scss";

export const PedigreeFolder = (props) => {
  const { email, folderId, onChange } = props;
  const localModuleName = `${MODULE_NAME}-new-invite-email-address`;
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    props.getData().then(setData);
  }, []);

  const handleBlur = React.useCallback((e) => {
    onChange({ email: e.target.value.trim(), folderId });
  }, [onChange, folderId]);

  const handleFolderChange = React.useCallback((selectedFolderId) => {
    onChange({ email, folderId: selectedFolderId });
  }, [onChange, email]);

  return (
    <div className="IndividualsPedigreeFolders">
      <h6 className="IndividualsPedigreeFolders__title">The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.</h6> 
      <h6 className="IndividualsPedigreeFolders__title">{I18n.t("What is the name of the new pedigree?")}</h6>
      <Flex justify="center" width="100%">
        <FormControl
          defaultValue={email}
          type="text"
          onBlur={handleBlur}
          {...getTestAttributes(localModuleName, 'email', 'input')}
        />
      </Flex>
      <h6 className="IndividualsPedigreeFolders__title">{I18n.t("Select a folder")}</h6>
      <Tree
        collapseAfterLevel={0}
        className="IndividualsPedigreeFolders__list"
        items={data}
        value={folderId}
        onChange={handleFolderChange} 
      />
    </div>
  );
};
